module.exports = __webpack_public_path__ + "static/media/marron.d99d952b.png";